import classNames from 'classnames';
import * as React from 'react';

import { getTranslation, keys } from '../../../Resources/Translations';
import { FormInputValidationIssues } from './FormInputValidationIssues';
import { FormField, FormFields, ValidationIssue, ValidationType } from './FormInterfaces';
import { getErrorId } from './GetErrorId';
import { getValidationIssue, isInputDisabled } from './GetValidationIssue';

interface FormInputProps {
    validateOnInit?: boolean;
    input: FormField;
    inputs: FormFields;
    name: string;
    onChange: (value: string, name: string, errors: ValidationIssue[], trim?: boolean) => void;
    setWasActive: (name: string) => void;
    collapseInput: (value: boolean, name: string) => void;
}

export const FormInput = (props: FormInputProps) => {
    const { input, inputs, onChange, name, setWasActive, collapseInput } = props;
    const isCollapsed = !!(input.isCollapsed && !input.value);

    const getIssueClass = (issues: ValidationIssue[]) => (issues[0].type === ValidationType.Warning ? 'NewForm__Warning' : 'NewForm__Error');

    const showIssue = (): string => {
        return input.validationIssues && input.validationIssues.length > 0 && (input.wasActive || props.validateOnInit)
            ? getIssueClass(input.validationIssues)
            : '';
    };

    const changeValue = (value: string, trim?: boolean) => {
        onChange(value, name, getValidationIssue(input, inputs, value), trim);
    };

    const handleOnBlur = () => {
        setWasActive(name);
        changeValue(input.value || '', true);
    };

    const getCollapseButton = () => {
        return (
            <button onClick={() => collapseInput(false, name)} className="NewForm__ShowInputButton" type="button">
                {input.collapseText || `${getTranslation(keys['form.show'])} ${input.displayName}`}
            </button>
        );
    };

    if (input.type === 'hidden') return null;

    const inputId = input.displayName?.replace(/\s/g, '').toLocaleLowerCase();

    return (
        <div className={classNames('NewForm__FieldWrapper', isInputDisabled(input, inputs) && 'NewForm__FieldWrapper--Disabled', showIssue())}>
            {isCollapsed ? (
                getCollapseButton()
            ) : (
                <>
                    <div className="NewForm__Field">
                        <label htmlFor={inputId}>
                            {input.displayName}
                            <span className="NewForm__FieldRequired">{input.validation?.required?.value && ' *'}</span>
                        </label>
                        <input
                            disabled={!!input.disabled}
                            inputMode={input.inputmode}
                            id={inputId}
                            aria-invalid={input.validationIssues && input.wasActive}
                            aria-describedby={input.validationIssues && input.wasActive ? getErrorId(input.displayName) : undefined}
                            onChange={(e) => changeValue(e.target.value)}
                            onBlur={handleOnBlur}
                            value={input.value || ''}
                            type={input.type || 'text'}
                            autoComplete={input.autocomplete}
                        />
                    </div>
                    <FormInputValidationIssues validationIssue={input.validationIssues} />
                </>
            )}
        </div>
    );
};
